import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { toastrConfig } from 'projects/is-ui-kit/src/lib/core/configs';
import { ActionToastComponent } from 'projects/is-ui-kit/src/lib/core/utils-initializer/utils/custom-notifiers/action-toast/action-toast.component';
import { GenericApiService } from 'projects/licenses-manager/src/app/core/generic-api.service';

@Component({
  selector: 'email-reset-password',
  templateUrl: './email-reset-password.component.html',
  styleUrls: ['./email-reset-password.component.scss']
})
export class EmailResetPasswordComponent {

  public resetPasswordForm: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email])
  });

  constructor(private _http: HttpClient,
    private _router: Router,
    private _toastr: ToastrService,
    private _translate: TranslateService,
    private _cd: ChangeDetectorRef,
    private _apiService: GenericApiService
  ) { }

  public goToLogin(): void {
    this._router.navigate(['/']);
  }

  public resetPasswordRequest(): void {

    const obj = {
      email: this.resetPasswordForm.get('email').value
    };
    this._apiService.resetPasswordRequest((error, response) => {
      if (error) {
        console.error('Errore nella creazione della licenza:', error);
      } else if (response) {
        this._router.navigate(['/']);
        const textToastr = this._translate.instant(response.detail);
        this.showCustomToast({
          type: 'success',
          info: textToastr
        });
      }
    }, obj);
  }

  public showCustomToast(options: {
    type: 'error' | 'success' | 'warning' | 'info';
    info: string;
    buttonText?: string;
  }): ActiveToast<any> {
    const activeToast = this._toastr[options.type](
      (options.info),
      null,
      {
        ...toastrConfig,
        ...{
          timeOut: 7000,
          closeButton: true,
          toastComponent: ActionToastComponent,
          tapToDismiss: false
        }
      }
    );
    activeToast.toastRef.componentInstance.buttonText = options?.buttonText;
    return activeToast;
  }

}
